// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2ORif","content":"styles_content__2B5Bn","selectAll":"styles_selectAll__3F4PZ"};